import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from "rxjs/operators";
import { Injectable } from "@angular/core"
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { LocalStorageService } from '../services/local-storage.service';
import { environment } from 'src/environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { InernetConnectionComponent } from 'src/app/components/all-modals/internet-connection/internet-connection.component';
import { ErrorMessageComponent } from 'src/app/components/all-modals/error-message/error-message.component';
import { WebsocketService } from '../services/websocket.service';
import { LOCAL_STORAGE_CONSTANT } from '../services/local-storage.constant';
import { LITERALS } from '../constants/literals.constant';

@Injectable()
export class Interceptor implements HttpInterceptor {
    chatToken = environment.chatToken;
    navigationExtras: NavigationExtras;
    internetModalRef: any;
    counter: number = 0;
    constructor(
        private router: Router,
        private modalService: NgbModal,
        private _localStorageService: LocalStorageService,
        private activatedRoute: ActivatedRoute,
        private modelServie: NgbModal,
        private webSocketService: WebsocketService,
        private spinner: NgxSpinnerService
    ) {
        this.activatedRoute.queryParams.subscribe((params) => {
            if (params && !params.redirect_url) {
                this.navigationExtras = {
                    queryParams: {
                        redirect_url: this.router.routerState.snapshot.url
                    }
                };
            }
        });
        this.counter++;
    }
    chatUrl = environment.socketUrl;
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (window.navigator.onLine) {

            let currentUser;
            let rememberMe = localStorage.rememberMe;

            if (rememberMe == 'true') {
                if (localStorage.currentUser) {
                    currentUser = JSON.parse(localStorage.currentUser);
                }
            }
            else {
                if (sessionStorage.currentUser) {
                    currentUser = JSON.parse(sessionStorage.currentUser);
                }
            }
            if (currentUser && currentUser.token) {
                request = request.clone({
                    setHeaders: {
                        Authorization: `${currentUser.token}`
                    }
                });
            }
            if (request.url.indexOf(this.chatUrl) > -1) {
                request = request.clone({
                    setHeaders: {
                        Authorization: `JWT ${this.chatToken}`
                    }
                });
            }
            // console.log('req', request.url.includes(this.chatUrl));
            return next.handle(request).pipe(
                tap(evt => {
                    if (evt instanceof HttpResponse) {
                        if (evt.body && evt.body.status == 401) {
                            this.modelServie.dismissAll();
                            const userData = this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS) ?
                            this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS).user : '';
                            this.webSocketService.offlineSocket(userData['chat_sku']);
                            this.webSocketService.disconnectSocket();
                            this._localStorageService.clearAll();
                            this.router.navigate(['/'], this.navigationExtras);
                            this.spinner.hide();
                            if(evt.body.errors){
                                // even after removing the modal.service we are getting redirection issue so if we get evt.error it will navigate to site
                                this.router.navigate([''])
                                // Had to comment this line because of the Pop-up issue
                                // const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
                                // modalRef.componentInstance.message = evt.body.errors;
                            }
                        }
                    }
                }));
        }
        else {
            if (this.counter == 1)
                this.showInternetErrorModal();
        }
    }
    showInternetErrorModal() {
        this.modelServie.dismissAll();
        this.internetModalRef = this.modelServie.open(InernetConnectionComponent, { backdrop: 'static', centered: true });
        this.internetModalRef.componentInstance.title = 'Internet Connection Error';
        this.internetModalRef.componentInstance.message = 'Check your connection and try again.';
        this.internetModalRef.result.then(() => {
            window.location.reload();
        });
    }
}